var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSurveyBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M19.889 3.2h-4.412C15.033 1.924 13.872 1 12.5 1c-1.372 0-2.533.924-2.977 2.2H5.111C3.95 3.2 3 4.19 3 5.4v15.4c0 1.21.95 2.2 2.111 2.2H19.89C21.05 23 22 22.01 22 20.8V5.4c0-1.21-.95-2.2-2.111-2.2zm-7.389 0c.58 0 1.056.495 1.056 1.1 0 .605-.475 1.1-1.056 1.1-.58 0-1.056-.495-1.056-1.1 0-.605.475-1.1 1.056-1.1zm0 6.737V7.876h6.786v2.063H12.5zm0 8.594V16.47h6.786v2.062H12.5zM5.71 12V6.5h5.43V12H5.71zM6.8 7.6v3.3h3.257V7.6H6.8zM5.71 19.906v-5.5h5.43v5.5H5.71zm1.09-4.468v3.3h3.257v-3.3H6.8z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#303d4d",
    fillRule: "nonzero",
    xlinkHref: "#a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSurveyBlack);
export default __webpack_public_path__ + "static/media/ic-survey-black.ca90cb3f87ef1602a58d123eac50417d.svg";
export { ForwardRef as ReactComponent };